import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H1, H2 } from 'components/common/Text/Text'
import { LazyDiv } from 'components/common/LazyHtml'
import { generateQualtricsScriptTag } from 'components/ContactUs/helpers.js'

const BOTContactUs = ({
  title,
  subtitle,
  contactUsText,
  isFleetServicesPage
}) =>
  <Wrapper data-at-contact-us>
    <Helmet>
      <script type="text/javascript">
        {generateQualtricsScriptTag()}
      </script>
    </Helmet>
    {/* <!--DO NOT REMOVE-CONTENTS PLACED HERE--> IT'S QUALTRICS CONTAINER */}
    <div id="ZN_aV7QuAtuek6kk5w" />
    {/* <!--DO NOT REMOVE-CONTENTS PLACED HERE--> IT'S QUALTRICS CONTAINER */}

    {isFleetServicesPage
      ? <Subtitle className="fleet-text-subtitle" data-at-subtitle headline_narrow>{ title }</Subtitle>
      : <Title data-at-title headline headline_narrow>{ title }</Title>}
    {subtitle && <Subtitle data-at-subtitle headline_narrow>{ subtitle }</Subtitle>}
    <LazyDiv data-at-text content={ contactUsText } />
    <Underline />
  </Wrapper>

export default BOTContactUs

BOTContactUs.propTypes = {
  contactUsText: PropTypes.string,
  isFleetServicesPage: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string
}

const Wrapper = styled.div`
  margin: 40px auto;
  ${Mixin.responsive('padding', '0', '0 20px')}
`

const Subtitle = styled(H2)`
  margin: 30px 0 20px;
  ${Mixin.font.GothamBold(26, 600)}
`

const Title = styled(H1)`
  margin-bottom: 10px;
  ${Mixin.font.GothamBold(34, 900)}
  ${Media.mobile`
    font-size: 26px;
    line-height: 26px;
  `}
`

const Underline = styled.div`
  width: 94%;
  margin: 0 auto;
  padding-top: 20px;
  border-bottom: 2px solid ${Theme.colors.light_grey};
`
